import {IElementWedlet, IWedlet, WEDLET} from "/@back@/edit/wed/wedlets/wedlet.js";
import {IJmlNode} from "/@lib@/commons/xml/jml.js";
import {DOMSH} from "/@lib@/commons/xml/domsh.js";
import {JSX} from "/@lib@/commons/xml/dom.js";
import {BoxContainer} from "/@back@/edit/wed/wedlets/box/boxTags.js";
import {IXmlMsg} from "/@lib@/edit/ot/xmlHouse.js";
import {LANG} from "/@lib@/commons/lang.js";
import {IReg, REG} from "/@lib@/commons/registry.js";
import {ORemoteResRendererExtendedInit, RemoteResRendererExtended} from "/@back@/core/widgets/remoteResRenderer.js";
import {JRemoteResDescFromClient, REMOTE} from "/@lib@/core/remote.js";
import {IBasicUniversePointer} from "/@lib@/core/universe.js";

/**
 * BoxRemoteView avec la nouvelle approche JRemoteResDesc à partir sc6.1
 * Affiche une ressource remote
 *    <box-remote-res-view initSvc?="shown{@see ORemoteResRendererExtendedInit}"/>
 */
export class BoxRemoteResView extends BoxContainer implements IElementWedlet {

	remoteResRendererElt: RemoteResRendererExtended;

	url: string;

	protected reg: IReg<IBasicUniversePointer>

	constructor() {
		super();
		this.style.userSelect = "none";
	}

	configWedletElt(tpl: Element, wedlet: IWedlet) {
		const wedMgr = wedlet.wedMgr;
		const sr = this.attachShadow(DOMSH.SHADOWDOM_INIT);
		WEDLET.installSkins(tpl, sr, wedlet, this.localName);
		this.reg = wedMgr.reg;
		const init: ORemoteResRendererExtendedInit = {
			reg: this.reg,
			fetchResDesc: this.fetchResDescFromBox.bind(this),
		};
		if (tpl.hasAttribute("initSvc"))
			Object.assign(init, wedMgr.reg.getSvc(tpl.getAttribute("initSvc")))

		this.remoteResRendererElt = sr.appendChild(<RemoteResRendererExtended î={init}/>) as RemoteResRendererExtended;
	}

	protected async fetchResDescFromBox(): Promise<JRemoteResDescFromClient> {
		return (await REMOTE.fetchResDesc(this.url, this.reg)) || {url: this.url, status: -1};
	}

	refreshBindValue(val: IJmlNode) {
		this.url = val as string;
		this.remoteResRendererElt.refresh();
		WEDLET.clearAnnots(this);
	}

	insertChars(from: number, chars: string, msg: IXmlMsg) {
		this.refreshBindValue(LANG.stringInsert(this.url, from, chars));
	}

	deleteChars(from: number, len: number, msg: IXmlMsg) {
		this.refreshBindValue(LANG.stringDelete(this.url, from, len));
	}

	replaceChars(chars: string, msg: IXmlMsg) {
		this.refreshBindValue(chars);
	}
}

window.customElements.define("box-remote-res-view", BoxRemoteResView);
REG.reg.registerSkin('box-remote-res-view', 1, /* language=CSS */ `
	:host {
		display: flex;
		min-height: 0;
		max-height: 15em;
	}
`);
